/* Hipland product cards: swipe through a card's images (touch), dots, hover preview on desktop. */
(function () {
  if (window.__hlCards) return; window.__hlCards = 1;
  function dots(track) {
    var wrap = track.parentNode.querySelector('.hl-card__dots'); if (!wrap) return;
    var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    var d = wrap.children; for (var k = 0; k < d.length; k++) d[k].className = k === i ? 'on' : '';
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target; if (t && t.matches && t.matches('[data-hl-track]')) dots(t);
  }, true);
  function setup() {
    document.querySelectorAll('[data-hl-track]').forEach(function (t) {
      if (t.__hl) return; t.__hl = 1; dots(t);
      var m = t.parentNode;
      if (window.matchMedia && window.matchMedia('(hover:hover)').matches && t.children.length > 1) {
        m.addEventListener('mouseenter', function () { t.scrollTo({ left: t.clientWidth, behavior: 'smooth' }); });
        m.addEventListener('mouseleave', function () { t.scrollTo({ left: 0, behavior: 'smooth' }); });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
